// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropzone{outline:1px dashed #ccc;background:#fff;color:#696969;padding:0;min-height:60px;position:relative;cursor:pointer}.input-file{opacity:0;width:100%;height:50px;position:absolute;cursor:pointer}.dropzone p{font-size:12px;color:#aaa;text-align:center;padding:20px 0}", ""]);
// Exports
module.exports = exports;
